import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ConnectorTag, IDiscrepancyPurgeableResponse } from '@bciti/types';
import { ToastrService } from 'ngx-toastr';
import { ReplaySubject, Subject } from 'rxjs';
import { switchMap, take, takeUntil, tap } from 'rxjs/operators';
import { ConfirmDialogComponent } from 'src/app/components/dialogs/confirm-dialog/confirm-dialog.component';
import { IBreadcrumbItem } from 'src/app/interfaces/breadcrumb/breadcrumb.interface';
import { DiscrepancyService } from 'src/app/services/discrepancy/discrepancy.service';

@Component({
    selector: 'app-discrepancies',
    templateUrl: './discrepancies.component.html',
    styleUrls: ['./discrepancies.component.scss'],
})
export class DiscrepanciesComponent implements OnInit {
    private destroy$ = new Subject();
    private update$ = new ReplaySubject();

    orgTag: string;
    loading = false;

    buttonText = 'Purge';

    breadcrumb: IBreadcrumbItem[] = [
        {
            link: '/organisations',
            title: 'Organisation',
        },
        {
            link: '',
            title: 'Data discrepencies',
        },
    ];

    currentDialog = null;

    connectors: IDiscrepancyPurgeableResponse[] = [];

    constructor(private route: ActivatedRoute, private discrepancyService: DiscrepancyService, private dialog: MatDialog, private toastrService: ToastrService) {}

    ngOnInit(): void {
        this.route.params.subscribe((param) => {
            if (param.tag) {
                this.orgTag = param.tag;
                this.update$
                    .pipe(
                        tap(() => (this.loading = true)),
                        switchMap(() =>
                            this.discrepancyService.getSystExtWithPurgeableData(param.tag).pipe(
                                takeUntil(this.destroy$),
                                tap((res) => {
                                    this.connectors = res;
                                    this.loading = false;
                                }),
                            ),
                        ),
                    )
                    .subscribe();

                this.update$.next();
            }
        });
    }

    get pageTitle() {
        return `DATA discrepencies : ${this.orgTag}`;
    }

    get connectorsPurgeable() {
        return this.connectors;
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    handlePurge(e: Event, connectorTag: ConnectorTag) {
        const data = {
            title: `Purge Data of ${connectorTag}`,
            body: 'This willl delete every card and externalIds bind to that external System',
            cancelLabel: 'Cancel',
            confirmLabel: 'Purge',
            confirmType: 'delete',
        };

        this.currentDialog = this.dialog.open(ConfirmDialogComponent, {
            data,
            autoFocus: false,
            panelClass: 'confirm-dialog',
        });

        this.currentDialog.componentInstance.onSubmit.subscribe((confirm) => {
            if (confirm) {
                this.currentDialog.componentInstance.data.loading = true;

                this.discrepancyService
                    .purgeData(this.orgTag, connectorTag)
                    .pipe(take(1))
                    .subscribe(
                        (response) => {
                            this.currentDialog.close(true);
                            this.toastrService.success('Data was purged, more data available in Logger -> Cerberus');
                        },
                        (error) => {
                            this.currentDialog.componentInstance.data.loading = false;
                            console.log(error);
                            this.toastrService.error(error.error.messages[0], `${error.error.status}`);
                        },
                    );
            } else {
                this.currentDialog.componentInstance.onSubmit.unsubscribe;
                this.currentDialog?.close();
                this.currentDialog = null;
            }
        });
    }
}
